export default __webpack_public_path__ + "static/media/2.2bf807d8.jpg";